import { notificationApi } from 'api/notification';

type MessageCallback = (data: any) => void;

const socketBaseUrl = process.env.REACT_APP_NOTIFICATION_API_URL || 'ws://localhost:8091';

class NotificationService {
  private socket: WebSocket | null = null;
  private listeners = new Set<MessageCallback>();
  private userId: string = '';
  private isManuallyClosed = false;
  private dispatch: any = null;

  setDispatch(dispatch: any) {
    this.dispatch = dispatch;
  }

  connect(userId: string) {
    if (this.socket?.readyState === WebSocket.OPEN) return;

    this.userId = userId;
    this.isManuallyClosed = false;

    this.socket = new WebSocket(`${socketBaseUrl}/event?userId=${userId}`);

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (this.dispatch) {
          this.dispatch(notificationApi.util.invalidateTags(['NOTIFICATION_LIST', 'UNREAD_NOTIFICATION_COUNT']));
        }
        this.listeners.forEach((cb) => cb(data));
      } catch (err) {
        console.error('[WS] Invalid message format:', event.data, err);
      }
    };

    this.socket.onclose = () => {
      if (!this.isManuallyClosed) {
        console.warn('[WS] Disconnected. Reconnecting in 5s...');
        setTimeout(() => this.connect(this.userId), 5000);
      }
    };

    this.socket.onerror = (err) => {
      console.warn('[WS] Error:', err);
      this.socket?.close();
    };
  }

  disconnect() {
    this.isManuallyClosed = true;
    this.socket?.close();
    this.socket = null;
    this.listeners.clear();
  }

  subscribe(callback: MessageCallback): () => void {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }
}

export const notificationService = new NotificationService();
